import React, { useState } from "react";

import Form from "./Form";
import { formDataObject } from "./formDataObject";
import { PageHeader } from "../../../components";

export default function RCMappingDetails() {
  const [rcDetails, setRcDetails] = useState({});
  const [formData, setFormData] = useState(formDataObject);

  return (
    <React.Fragment>
      <PageHeader pageName="Reverse RC  Details" />

      <Form
        formData={formData}
        setFormData={setFormData}
        rcDetails={rcDetails}
        setRcDetails={setRcDetails}
      />
    </React.Fragment>
  );
}
